
// (name: string): string | null
export const getCookieValue = (name) => {
    const cookie = document.cookie ?? null

    if (!cookie || !name) return null

    const match = cookie.match(new RegExp(`${name}=([^;]+)`))

    return match ? match[1] : null
}


// WEBPACK FOOTER //
// ./src/libs/cookie/index.js